import axios from "axios";
import { Landing } from "../../../domain/landing/landing";
import { Configuration, LandingsApi, LandingLandingResponse } from "../generated";

export class LandingsRepository {
    private service: LandingsApi;

    constructor() {
        this.service = new LandingsApi(new Configuration(), process.env.REACT_APP_BACKEND_URL)
    }

    async ReadLandings(): Promise<Landing[] | Error> {
        try {
            let response = await this.service.apiLandingGet({ headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                let landings : Landing[] = []
                response.data?.map((landingApi) => {
                    let landing = this.toDomainLanding(landingApi);
                    landings.push(landing)
                })
                return landings
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async CreateLanding(domain: string,imagesPath: string,isWithThumb: boolean,thumbWidth: number,thumbHeight: number,thumbPostfix: string,bigImageWidth: number,): Promise<Landing | Error> {
        try {
            let response = await this.service.apiLandingPost({ domain: domain,images_path: imagesPath,is_with_thumb: isWithThumb,thumb_width: thumbWidth,thumb_height: thumbHeight,thumb_postfix: thumbPostfix,big_image_width: bigImageWidth, }, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 201) {
                let landing = this.toDomainLanding(response.data);
                return landing
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async UpdateLanding(id: string,domain: string,imagesPath: string,isWithThumb: boolean,thumbWidth: number,thumbHeight: number,thumbPostfix: string,bigImageWidth: number,): Promise<Landing | Error> {
        try {

            let response = await this.service.apiLandingIdPut(id, { domain: domain,images_path: imagesPath,is_with_thumb: isWithThumb,thumb_width: thumbWidth,thumb_height: thumbHeight,thumb_postfix: thumbPostfix,big_image_width: bigImageWidth, }, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                let landing = this.toDomainLanding(response.data);
                return landing
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async ReadLandingById(id: UniqueId): Promise<Landing | Error> {
        try {

            let response = await this.service.apiLandingIdGet(id, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                let landing = this.toDomainLanding(response.data);
                return landing
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async DeleteLandingById(id: UniqueId): Promise<string | Error> {
        try {

            let response = await this.service.apiLandingIdDelete(id, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return id
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }
    

    toDomainLanding(landing: LandingLandingResponse): Landing {
        return new Landing( landing.id!, landing.domain!, landing.images_path!, landing.is_with_thumb!, landing.thumb_width!, landing.thumb_height!, landing.thumb_postfix!, landing.big_image_width!, new Date(landing.created_at!), new Date(landing.modified_at!), );
    }
    
}